<template>
    <div>
        <nav-breadcrumb :menu="[{label: '法务大数据查询'}]"/>
        <el-form :model="dataForm" ref="dataForm" label-width="180px">
            <el-row>
                <panel border>
                    <el-col :span="24">
                        <el-form-item label="姓名：" prop="f__name" >
                           {{dataForm.f__name}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="查询时间：" prop="f__queryTime">
                            {{dataForm.f__queryTime|moment('YYYY-MM-DD HH:mm:ss')}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="查询结果：" prop="f__identity">
                            查询到<span style="color:red">{{count}}</span>条相关数据
                        </el-form-item>
                    </el-col>
                </panel>
            </el-row>
        </el-form>
        <panel  v-for="(key, idx) in Object.keys(tableData)" :key="idx" :label="Status2CN(key)">
            <data-table
                :table-data="tableData[key]"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :is-pagination-show="false"
            />
        </panel>
    </div>
</template>

<script>
import xhr from "../../utils/xhr";
import moment from "moment";
import Status2CN from "../../filters/Status2CN";
import {removeItem} from "../../filters/CommonActions";
import Panel from "../../components/Panel";

export default {
    name: "FaihaiQueryPersonView",
    components: {Panel},
    data(){
        return {
            queryId: this.$route.query['queryId']||'',
            count:0,
            dataForm:{
                detail:[]
            },
            tableData:[],

            page: 1,
            pageSize: 100,
            columns:[
                {
                    type: 'index'
                },
                {
                    label: '时间',
                    field: '',
                    formatter: function (r,c,v) {
                        let body = JSON.parse(r.d__body)
                        let type = ''
                        Object.keys(body).forEach(item=>{
                            if(item!=='code'&&item!=='msg'&&item!=='searchSeconds'&&item!=='totalCount'){ type = item}
                        })
                        return body[type][0].sortTime?moment(body[type][0].sortTime).format('YYYY-MM-DD'):''
                    }
                },
                {
                    label: '类型',
                    field: '',
                    formatter: function (r,c,v) {
                        var body = JSON.parse(r.d__body)
                        var type = ''
                        Object.keys(body).forEach(item=>{
                            if(item!=='code'&&item!=='msg'&&item!=='searchSeconds'&&item!=='totalCount'){ type = item}
                        })
                        return Status2CN(type)

                    }
                },
                {
                    label: '标题',
                    field: '',
                    formatter: function (r,c,v) {
                        let body = JSON.parse(r.d__body)
                        let type = ''
                        Object.keys(body).forEach(item=>{
                            if(item!=='code'&&item!=='msg'&&item!=='searchSeconds'&&item!=='totalCount'){ type = item}
                        })
                        return body[type][0].title
                    }
                },
                /*{
                    label: '内容',
                    field: '',
                    formatter: function (r,c,v) {
                        let body = JSON.parse(r.d__body)
                        let type = ''
                        Object.keys(body).forEach(item=>{
                            if(item!=='code'&&item!=='msg'&&item!=='searchSeconds'&&item!=='totalCount'){ type = item}
                        })
                       // return body[type][0].body
                    }
                },*/
                {
                    label: '操作',
                    opts: [
                        {
                            label: '查看',
                            class: 'el-icon-view',
                            clickHandler: (index, row) => {
                                this.$router.push({
                                    name: 'FaihaiQueryPersonDetailView',
                                    query: {
                                        'row': row.d__body,
                                    }
                                })
                            },
                        }
                    ]
                }
            ]
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        Status2CN,
        getData: function () {
            xhr.getFaihaiView({
                'f.queryId': this.queryId
            }, res=> {
                try {
                        this.dataForm = res.data.data
                        let arr = {}
                        let count = 0
                        res.data.data.detail.forEach(item=>{
                            let body = JSON.parse(item.d__body)
                            let type = ''
                            Object.keys(body).forEach(item=>{
                                if(item!=='code'&&item!=='msg'&&item!=='searchSeconds'&&item!=='totalCount'){ type = item}
                            })
                            if(type in arr){
                               arr[type]['data'].push(item)
                                count++

                            }else {
                                this.$set(arr, type, {data:[item]})
                                count++
                            }

                        })

                   this.tableData = arr
                    this.count = count

                } catch (e) {
                }
            })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FaihaiQueryPersonView.vue